module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_2-d9d15a9b270e789daf5fe878734416af.jpg";